
$(function () {
    $('input[name="deliverytype"]').on('change', function () {

        if ($('input[name="deliverytype"]:checked').val() === 'named') {
            $('#containerSpecificDeliveryDate').slideDown();
        } else {
            $('#containerSpecificDeliveryDate').slideUp();
        }
    });
});
